// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__28bGE","content":"styles_content__2P5Xm","selectAll":"styles_selectAll__kF2ig"};